import { render, staticRenderFns } from "./EntertainRegister.vue?vue&type=template&id=84118e32&"
import script from "./EntertainRegister.vue?vue&type=script&lang=js&"
export * from "./EntertainRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports